<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
></aur-mat-table>

